import { useApi } from '@/api';
import { Blockie, EntityName, Page, PageSkeleton } from '@/components';
import {
  ArrowRightIcon,
  CryptoIcon,
  Heading,
  textShortener,
  useTableProps
} from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
export default function StakingEngineUrnActivityPage() {
  const { urn } = useParams();
  const ilk = 'LSEV2-SKY-A';

  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/cdps/${urn}/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="4"
              />
            }
            symbol2={<Blockie address={urn} imgSize="4" />}>
            <Heading size="1">
              {ilk.toUpperCase()} <ArrowRightIcon size="2" />{' '}
              {textShortener(urn)} Activity
            </Heading>
          </EntityName>
        }>
        <HistoricTabs ilk={ilk} urn={urn} />
        <EventsTable
          data={data}
          pagination={pagination}
          sorting={sorting}
          collateralSymbol={data.collateral_symbol}
          collateralAddress={data.collateral_address}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
